export const vendorsApi = (client) => ({
    list: (params) => client.get('/api/v1/vendors', { params }).then((r) => r.data),
    get: (id) => client.get(`/api/v1/vendors/${id}`).then((r) => r.data),
    create: (body) => client.post('/api/v1/vendors', body).then((r) => r.data),
    update: (id, body) => client.patch(`/api/v1/vendors/${id}`, body).then((r) => r.data),
    remove: (id) => client.delete(`/api/v1/vendors/${id}`).then((r) => r.data),
    /// Soft-delete up to 200 vendors in one call (best-effort cleanup of
    /// any associated MinIO documents happens server-side first).
    bulkRemove: (ids) => client.post('/api/v1/vendors/bulk-delete', { ids }).then((r) => r.data),
    // Documents
    listDocuments: (id) => client.get(`/api/v1/vendors/${id}/documents`).then((r) => r.data),
    uploadDocument: (id, file, onProgress) => {
        const form = new FormData();
        form.append('file', file);
        return client.post(`/api/v1/vendors/${id}/documents`, form, {
            headers: { 'Content-Type': 'multipart/form-data' },
            onUploadProgress: (e) => { if (onProgress && e.total)
                onProgress(Math.round((e.loaded / e.total) * 100)); },
        }).then((r) => r.data);
    },
    viewDocument: (id, docId) => client.get(`/api/v1/vendors/${id}/documents/${docId}/view`, { responseType: 'blob' }).then((r) => r),
    deleteDocument: (id, docId) => client.delete(`/api/v1/vendors/${id}/documents/${docId}`).then((r) => r.data),
});
//# sourceMappingURL=vendors.js.map